exports.disableCorePrefetching = () => true;
